var _defs, _g, _rect, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_134_84",
    "data-name": "Component 134 \\u2013 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.733,
    height: 66.299,
    viewBox: "0 0 58.733 66.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1643",
    "data-name": "Rectangle 1643",
    width: 58.733,
    height: 66.299,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M31.221,0c1.172.164,2.352.285,3.514.5a28.54,28.54,0,0,1,16.881,9.7,28.558,28.558,0,0,1,7.029,21.43A29.275,29.275,0,0,1,38.434,57.253a9.553,9.553,0,0,1-1.677.477,2.609,2.609,0,0,0-1.843,1.235c-1.688,2.321-3.429,4.6-5.152,6.9-.1.133-.215.253-.373.437l-1.965-2.615c-1.283-1.708-2.547-3.431-3.863-5.113a2.166,2.166,0,0,0-1.069-.713c-10.469-2.817-17.72-9.285-20.956-19.6C-2,26.964.615,16.852,8.934,8.37A27.844,27.844,0,0,1,23.57.588C24.687.36,25.831.271,26.963.115c.212-.029.421-.076.631-.115ZM7.873,29.218A21.535,21.535,0,1,0,29.4,7.654,21.574,21.574,0,0,0,7.873,29.218",
    transform: "translate(0)",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 47.101,
    height: 47.101,
    rx: 23.55,
    transform: "translate(5.816 6.155)",
    fill: "#05ce78"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons-Search-Line",
    transform: "translate(18.25 18.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.123,22.235a1.107,1.107,0,0,1-.773-.312L14.356,15.93A8.818,8.818,0,0,1,8.9,17.8a8.9,8.9,0,1,1,7.026-3.443l5.992,5.993a1.119,1.119,0,0,1-.013,1.56A1.107,1.107,0,0,1,21.123,22.235ZM8.9,2.225a6.674,6.674,0,1,0,4.72,1.954A6.682,6.682,0,0,0,8.9,2.225Z",
    transform: "translate(0 0)",
    fill: "#fcfcfd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.a2a44bdb6114bb1a7e79356506111b02.svg";
export { ForwardRef as ReactComponent };